//@flow
import * as React from 'react'
import { Field } from 'redux-form'
import styles from './styles'
import renderTextField from '../../../components/MaterialUi/renderTextField';
import RFSelectField from '../../../components/ReduxFormComps/RFSelectField';

import type { SelectOrTextField$Props } from '../flowTypes'

const SelectOrTextField=(props:SelectOrTextField$Props)=>{
    if (!props.isOverride){
        return (
            <Field
                label={props.label}
                name={props.selectField}
                datas={props.datas}
                component={RFSelectField}
                codeField={props.selectDataElement.code}
                descField={props.selectDataElement.desc}
                customStyle={props.selectCustomStyle?props.selectCustomStyle:{width: '290px' }}
            />
        )
    }else {
        return (
            <Field
                name={props.textField}
                component={renderTextField}
                label={props.label}
                style={styles.textFieldStyle}
            />
        )
    }
}

export default SelectOrTextField


// WEBPACK FOOTER //
// ./src/views/ProjectDemeter/common/SelectOrTextField.js